import $ from 'jquery';
Quad.AvailableLoads = (function () {


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  var moment = require('moment');
  function _init() {
    require('datatables.net');
    require('datatables.net-dt');
    require('datatables.net-buttons-dt');
    require('datatables.net-fixedheader-dt');
    require('datatables.net-responsive-dt');

    //Additional function to help with table sorting by date
    $.fn.dataTable.render.moment = function ( from, to, locale ) {
      // Argument shifting
      if ( arguments.length === 1 ) {
        locale = 'en';
        to = from;
        from = 'YYYY-MM-DD';
      }
      else if ( arguments.length === 2 ) {
        locale = 'en';
      }

      return function ( d, type, row ) { 
        if(d){
          var m = moment( d, from, locale, true );
          // Order and type get a number value from Moment, everything else
          // sees the rendered value
          return m.format( type === 'sort' || type === 'type' ? 'x' : to );
        }
        else {
          return "TBD";
        }
      };
    };

    $('#available-loads-table').DataTable({
      "oLanguage": {
        "sLengthMenu": "Display _MENU_ loads",
      },
      "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
      ajax: {
        url: "https://spedi.quad.com/QWExpress/AvailableLoads",
        dataSrc: '',
        dataType: 'jsonp'
      },
      columns: [
        {
          title: "Load Number", data: "LoadNumber",
          render: function (data) {
            return '<i class="icon-down-open"></i>' + data
          }
        },
        { title: "Ship City", data: "ShipCity" },
        { title: "Ship State", data: "ShipState" },
        { title: "Drops", data: "Drops" },
        { title: "Consignee State", data: "ConsigneeState" },
        { title: "Weight (LB)", data: "Weight" },
        { title: "Pickup Date", data: "PickupDateObject" ,
          render: $.fn.dataTable.render.moment(this.data, 'M/D/YYYY h:mm:ss A' )
        },
        { title: "Equip", data: "Equip" }
      ],
      responsive: {
        details: {
          renderer: function (api, rowIdx, columns) {
            var data = $.map(columns, function (col, i) {
              return col.hidden ?
                '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                '<td>' + col.title + ':' + '</td> ' +
                '<td>' + col.data + '</td>' +
                '</tr>' :
                '';
            }).join('');

            return data ?
              $('<table/>').append(data) :
              false;
          }
        }
      }
    });
    $(document).ready(function () {
      $('tbody').on('click', 'td', function () {
        $(this).find('i').toggleClass('icon-up-open icon-down-open ')
      });
    })

  }

  return {
    init: _init
  };

})();
